export default {
	import: {
		successMessage: 'Product info successfully uploaded. It could take up to 30 minutes for the result to take effect.',
	},
};
